import React from 'react';
import { config } from '../../../../config';

const PrivacyPolicy: React.FC = () => {
    return (
        <div className="card">
            <div className="card-body">
                <h1><strong>Privacy Policy</strong></h1>
                <br />
                <h2><strong>Introduction</strong></h2>
                <p>Video Job Fairs&nbsp;is committed to protecting the privacy and security of your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website&nbsp;or&nbsp;use our services.</p>
                <br />
                <h2><strong>Information We Collect</strong></h2>
                <br />
                <h3><strong>Personal Information You Provide</strong></h3>
                <br />
                <p>We may collect personal information that you voluntarily provide to us, including:</p>
                <br />
                <ul>
                    <li><strong>Contact Information:</strong>Name, email address, phone number, mailing address, job title, and company name</li>
                    <li><strong>Business </strong><strong>Information:</strong>Staffing requirements &amp; related details</li>
                    <li><strong>Communication Records:</strong>Information from emails, phone calls, meetings, and other communications</li>
                    <li><strong>Account Information:</strong>Login credentials and preferences for any client portals or platforms we provide</li>
                    <li><strong>Payment Information:</strong>Billing address and payment details (processed through secure third-party payment processors)&nbsp;</li>
                </ul>
                <br />
                <h3><strong> Mobile numbers and text messaging</strong></h3>
                <br />
                <p>We use mobile numbers solely to deliver SMS messages you request, such as event reminders and interview notifications. We do not sell or share mobile numbers, consent status, or SMS message data with third parties or affiliates for their marketing or promotional purposes. We may share information only with service providers to operate the SMS program. Message frequency may vary. Message and data rates may apply. Reply STOP to opt out, HELP for help. </p>
                <br />
                <h3><strong>Information Collected Automatically</strong></h3>
                <br />
                <p>When you visit our website or use our services, we may automatically collect:</p>
                <br />
                <ul>
                    <li><strong>Technical Information:</strong>IP address, browser type, operating system, device information, and browsing behavior</li>
                    <li><strong>Usage Data:</strong>Pages visited, time spent on our website, links clicked, and interaction patterns</li>
                    <li><strong>Cookies and Tracking Technologies:</strong>Information collected through cookies, web beacons, and similar technologies</li>
                </ul>
                <br />
                <h2><strong>How We Use Your Information</strong></h2>
                <br />
                <p>Your information is made available only to the employer for whom the Job Fair is being held. We do not send your information or make it available to any other parties.</p>
                <br />
                <h2><strong>Information Sharing and Disclosure</strong></h2>
                <br />
                <p>Your information is stored securely via cloud hosting and data storage. Other than the employer for whom the Job Fair is being held, your data is not shared with any third-party service provider.</p>
                <br />
                <h2><strong>Data Security</strong></h2>
                <br />
                <p>We implement appropriate technical and organizational measures to protect your personal information, including:</p>
                <br />
                <ul>
                    <li><strong>Encryption:</strong>Data encryption in transit and at rest</li>
                    <li><strong>Access Controls:</strong>Restricted access to personal information on a need-to-know basis</li>
                    <li><strong>Security Training:</strong>Regular security training for our employees</li>
                    <li><strong>Monitoring:</strong>Continuous monitoring for security threats and vulnerabilities</li>
                    <li><strong>Incident Response:</strong>Procedures for responding to data breaches and security incidents</li>
                </ul>
                <br />

                <h2><strong>Your Rights and Choices</strong></h2>
                <br />
                <p>Depending on your location, you may have the following rights:</p>
                <br />
                <h3><strong>Access and Portability</strong></h3>
                <br />
                <ul>
                    <li>Request access to the personal information we hold about you</li>
                    <li>Receive a copy of your personal information in a portable format</li>
                </ul>
                <br />
                <h3><strong>Correction and Updates</strong></h3>
                <br />
                <ul>
                    <li>Request correction of inaccurate or incomplete personal information</li>
                    <li>Update your contact preferences and communication settings</li>
                </ul>
                <br />
                <h3><strong>Deletion and Restriction</strong></h3>
                <br />
                <ul>
                    <li>Request deletion of your personal information (subject to legal and business requirements)</li>
                    <li>Request restriction of processing in certain circumstances</li>
                </ul>
                <br />
                <h3><strong>Objection and Withdrawal</strong></h3>
                <br />
                <ul>
                    <li>Object to certain processing activities</li>
                    <li>Withdraw consent where processing is based on consent</li>
                </ul>
                <br />
                <h3><strong>Data Protection Complaints</strong></h3>
                <br />
                <ul>
                    <li>Lodge complaints with relevant data protection authorities</li>
                </ul>
                <p>To exercise these rights, please contact us using the information provided below.</p>
                <br />
                <h2><strong>Cookies and Tracking Technologies</strong></h2>
                <br />
                <p>Our website uses cookies and similar technologies to:</p>
                <br />
                <ul>
                    <li>Ensure proper functioning of our website</li>
                    <li>Analyze website usage and performance</li>
                    <li>Personalize your experience</li>
                    <li>Provide relevant content and advertisements</li>
                </ul>
                <br />
                <p>You can manage your cookie preferences through your browser settings, though some features may not function properly if cookies are disabled.</p>
                <br />
                <h2><strong>Data Retention</strong></h2>
                <br />
                <p>We retain personal information for as long as necessary to:</p>
                <ul>
                    <li>Fulfill the purposes for which it was collected</li>
                    <li>Comply with legal obligations</li>
                    <li>Resolve disputes and enforce agreements</li>
                    <li>Maintain business records and continuity</li>
                </ul>
                <br />
                <p>Retention periods vary based on the type of information and applicable legal requirements.</p>
                <br />
                <h2><strong>Children&rsquo;s Privacy</strong></h2>
                <br />
                <p>Our services are not directed to individuals under the age of 16. We do not knowingly collect personal information from children under 16. If we become aware that we have collected such information, we will take steps to delete it promptly.</p>
                <br />
                <h2><strong>Third-Party Links</strong></h2>
                <br />
                <p>Our website may contain links to third-party websites. We are not responsible for the privacy practices of these external sites. We encourage you to review the privacy policies of any third-party websites you visit.</p>
                <br />
                <h2><strong>Updates to This Privacy Policy</strong></h2>
                <br />
                <p>We may update this Privacy Policy periodically to reflect changes in our practices, technology, or legal requirements. We will notify you of material changes through:</p>
                <br />
                <ul>
                    <li>Email notifications to registered users</li>
                    <li>Prominent notices on our website</li>
                    <li>Direct communication for significant changes</li>
                </ul>
                <br />
                <h2><strong>Contact Information</strong></h2>
                <br />
                <p>If you have questions, concerns, or requests regarding this Privacy Policy or our privacy practices, please contact us:</p>
                <p><strong>Video Job Fairs LLC</strong><br />Email: [<a href={`mailto:support@${config.amplifyDomain}`}>support@{config.amplifyDomain}</a>]<br />Phone:&nbsp;+1-7038501853<br />Address:&nbsp;8651 Oak Chase Circle, Fairfax Station, Virginia, 22039, U.S.</p>
                <p>&nbsp;</p>
                <p>For data protection inquiries specifically, you may also contact our Data Protection Officer at [<a href={`mailto:support@${config.amplifyDomain}`}>support@{config.amplifyDomain}</a>].</p>
                <br />
                <h2><strong>Jurisdiction-Specific Provisions</strong></h2>
                <br />
                <h3><strong>California Residents (CCPA)</strong></h3>
                <p>California residents have additional rights under the California Consumer Privacy Act, including the right to know what personal information is collected, the right to delete personal information, and the right to opt-out of the sale of personal information.</p>
            </div>
        </div>
    );
};

export default PrivacyPolicy;